import { render, staticRenderFns } from "./stateadminList.vue?vue&type=template&id=81b7e7da&scoped=true&"
import script from "./stateadminList.vue?vue&type=script&lang=js&"
export * from "./stateadminList.vue?vue&type=script&lang=js&"
import style0 from "./stateadminList.vue?vue&type=style&index=0&id=81b7e7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b7e7da",
  null
  
)

export default component.exports